/**

 * @作者 王

 * @创建于 2021/5/14 16:33

 */
export const menuListRouter = [
        ];


let arr = [];
let toPermission = (obj)=>{
    let json = {
        name: obj.label,
        code: obj.name,
        type: obj.type,
        elementCodes:obj.elementCodes
    };
    if(Array.isArray(json.elementCodes) && json.elementCodes.length>0){
        json.elementCodes.forEach(item => {
            item.code = item.name;
            item.name = item.label
        })
    }
    if(Array.isArray(obj.children) && obj.children.length>0){
        json.children = [];
        obj.children.forEach(i=>{
            json.children.push(toPermission(i))
        })
    }
    return json
};
menuListRouter.forEach(i=>{
    arr.push(toPermission(i))
});

export const menuList =  arr
